export default __webpack_public_path__ + "static/media/dash_2.bf49bb28.svg";